__turbopack_context__.v({
  "backgroundImageWrapper": "cpAvpa_backgroundImageWrapper",
  "desktopMarqueeWrapper": "cpAvpa_desktopMarqueeWrapper",
  "heroSection": "cpAvpa_heroSection",
  "imageHalf": "cpAvpa_imageHalf",
  "mobileMarqueeWrapper": "cpAvpa_mobileMarqueeWrapper",
  "mobileText": "cpAvpa_mobileText",
  "mobileTextSection": "cpAvpa_mobileTextSection",
  "slantedText": "cpAvpa_slantedText" + " " + __turbopack_context__.i(527070)["body2"],
  "slantedTextOverlay": "cpAvpa_slantedTextOverlay",
  "styledImage": "cpAvpa_styledImage",
  "styledPicture": "cpAvpa_styledPicture",
});
